import React, { Component, Fragment } from 'react';
import { debounce } from 'lodash';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import swal from 'sweetalert';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as JourneysActions, Selectors as JourneysSelectors } from 'store/ducks/journeys';

import { Page, Panel, Button, Icon, Loading, Pagination, Form } from 'components';

class List extends Component {
  constructor(props) {
    super(props);

    this.handleSearch = debounce(props.getJourneysRequest, 300);
  }

  state = {
    query: '',
  };

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    const { getJourneysRequest } = this.props;
    getJourneysRequest(params.page);
  }

  componentDidUpdate(oldProps) {
    const { location } = this.props;

    if (queryString.parse(oldProps.location.search).page !== queryString.parse(location.search).page) {
      this.props.getJourneysRequest(queryString.parse(location.search).page);
    }
  }

  handleChangeQuery = e => {
    const { value } = e.target;

    this.setState({ query: value });
    this.handleSearch(1, value);
  };

  handleDelete = async id => {
    const confirm = await swal({
      title: 'Deseja remover?',
      text: 'Tem certeza de que deseja remover esta jornada?',
      type: 'info',
      buttons: {
        cancel: 'Não',
        confirm: {
          text: 'Sim',
        },
      },
    });

    if (confirm) {
      this.props.deleteInterviewRequest(id);
    }
  };

  render() {
    const { journeys } = this.props;
    const { query } = this.state;

    return (
      <Page>
        <div className="row align-items-center">
          <div className="col-6">
            <Page.Title>Jornadas</Page.Title>
          </div>

          <div className="col-6 text-right">
            <Link to="/admin/journeys/create" className="btn btn-success">
              Adicionar Nova
            </Link>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6 col-lg-3 m-b-10">
            <Form onSubmit={e => e.preventDefault()}>
              <Form.Input name="query" placeholder="Buscar por Nome" value={query} onChange={this.handleChangeQuery} />
            </Form>
          </div>
        </div>

        <Panel>
          {!journeys.data.length && journeys.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {journeys.loading && <Loading type="table" size="x-large" />}

              <table className="table table-stripped">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Data de início</th>
                    <th>Data de término</th>
                    <th />
                  </tr>
                </thead>

                <tbody>
                  {journeys.data.map(journey => (
                    <tr key={String(journey.id)}>
                      <td>{journey.attributes.name}</td>
                      <td>{journey.attributes.available_from}</td>
                      <td>{journey.attributes.available_until}</td>
                      <td className="text-right">
                        <Link to={`/admin/journeys/${journey.id}/edit`} className="btn btn-inverse btn-sm m-r-5">
                          <Icon name="pencil-alt" />
                        </Link>

                        <Button className="btn btn-inverse btn-sm m-r-5" onClick={() => this.handleDelete(journey.id)}>
                          <Icon name="trash" />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Fragment>
          )}
        </Panel>

        <Pagination className="m-t-20" current={journeys.page} total={journeys.total} {...this.props} />
      </Page>
    );
  }
}

const mapState = state => ({
  journeys: {
    ...state.journeys,
    data: JourneysSelectors.list(state.journeys.data),
  },
});

const mapActions = dispatch => bindActionCreators(JourneysActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(List);



// WEBPACK FOOTER //
// ./src/pages/Admin/Journeys/List/index.js